import { FC, useEffect } from 'react';
import { Stack } from '@mantine/core';
import { IconUsers } from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import { useDisclosure } from '@mantine/hooks';

import { CardContainer } from '../../cardContainer';
import { IListItemProps, ListItem } from '../../listItem';
import { ROUTES } from '@/containers/routes/constants';
import { CreateUserModal } from '@/containers/pages/user/feature/create-user';
import useHomeWidgetSlice from '@/store/homeWidget/useHomeWidgetSlice';

interface IUsersSectionProps {
  filialId: number;
  subscriptionPage?: boolean;
}

export const UsersSection: FC<IUsersSectionProps> = ({ filialId, subscriptionPage }) => {
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const [{ data }] = useHomeWidgetSlice().useUsersWidget().useState();
  const { LoadUsersSection } = useHomeWidgetSlice().actions;

  useEffect(() => {
    LoadUsersSection(filialId);
  }, []);

  const usersMenu: IListItemProps = {
    withCheck: false,
    items: [
      {
        name: t('users.list'),
        link: ROUTES.users.path,
        badge: data?.TotalCount
      },
      {
        name: t('filials.modules.addUser'),
        openModal: open
      },
      {
        name: t('filials.linkInvite'),
        link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.auth.invite}`
      }
    ]
  };

  return (
    <>
      <CardContainer
        sectionName={t('navigation.users')}
        Icon={IconUsers}
        subscriptionPage={subscriptionPage}
      >
        <Stack gap="11px" sx={{ width: '100%' }}>
          <ListItem items={usersMenu.items} withCheck={usersMenu.withCheck} />
        </Stack>
      </CardContainer>
      {opened && (
        <CreateUserModal
          opened={opened}
          modalClose={close}
          onSuccess={() => LoadUsersSection(filialId || 0)}
        />
      )}
    </>
  );
};
